<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <span class="text-muted text-uppercase">{{question.label}}</span>
      </b-card-header>
      <div class="py-3 px-5">
        <label>Form Level</label>
        <p>{{question.form_level}}</p>
      </div>
      <div class="py-3 px-5">
        <label>Input Type</label>
        <p>{{question.input_type}}</p>
      </div>
      <div class="py-3 px-5">
        <label>Values</label>
        <p>{{question.values}}</p>
      </div>
    </b-card>
  </div>
</template>

<script>

  export default {
    name: "ServiceQuestionCard",
    props: ["question"],
    data() {
      return {}
    },
    methods: {}
  }

</script>
